import { createI18n } from 'vue-i18n'
import el from './locales/el.json'
import en from './locales/en.json'

const savedLocale = localStorage.getItem('tc_locale') || 'el'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { el, en }
})

export default i18n